<template>
    <v-dialog
        persistent
        v-model="open"
        max-width="700px"
    >
        <v-card v-if="errorMessage" color="white">
            <v-card-title class="aprocon-blue text-element white--text">
               <span>
            <v-icon dark left>fas fa-exclamation-circle</v-icon>
                   Bestellhistorie
               </span>
                <v-spacer />
            </v-card-title>
            <v-card-text class="pt-6 pb-2">{{ errorMessage }}</v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="close" depressed>Ok</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-else color="white">
            <v-card-title class="text-element">
                <span>Bestellhistorie {{ artikelBezeichnung() }}</span>
                <v-spacer />
            </v-card-title>
            <v-card-text style="height: calc(100% - 65px)">
                <p>Bitte wählen Sie den Eintrag aus, dessen Menge und Einheit übernommen werden soll.</p>
                <aprocon-table  ref="table"
                                class="mb-8"
                                :service-url="$store.getters['Auth/serviceUrl']"
                                :user-id="$store.getters['Auth/userId']"
                                :auth-token="$store.getters['Auth/authToken']"
                                :table-name="gridName"
                                :context="context"
                                :parent-record-id="parentRecordId()"
                                :errorHandler="errorHandler"
                                @update:selected="updateSelected">
                    <template #loading-overlay>
                        <v-layout justify-center align-center fill-height>
                            <v-progress-circular indeterminate/>
                        </v-layout>
                    </template>
                </aprocon-table>
            </v-card-text>
            <v-card-actions class="aprocon-form">
                <v-spacer/>
                <v-btn @click="close" plain>
                    <span>Abbrechen</span>
                </v-btn>
                <v-btn @click="save" color="primary" :disabled="(!selected || selected.length === 0 || !canUpdate)">
                    <span>Übernehmen</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {
    AproconTable,
    ErrorHandler, FormErrorHandlerParams, FormErrorHandlerResponse,
    TableErrorHandlerParams,
    TableErrorHandlerResponse
} from '@aprocon-software/aprocon-form';
import {globalEventBus} from "@/main";

@Component({ components: {AproconTable}})
export default class ArticleHistoryDialog extends Vue {

    private parentRecordId(){
        return this.parentId;
    }
    private artikelBezeichnung() {
        if(this.parentItem) {
            return " - " + this.parentItem.ART_BEZEICHNUNG;
        }

        return "";
    }
    private parentItem:any = undefined;
    private updateSelected(items:any[]) {
        this.selected = items;
    }

    private async handleFormError(params: FormErrorHandlerParams): Promise<FormErrorHandlerResponse> {
        if (params.error) {
            //console.log(params.error);
            // logout
            if (params.error.id && params.error.id === 10003) {
                await this.$store.commit("Auth/setAuthToken", '');
                await this.$ports.auth.logout();
            }
            if (params.error.message) {
                await globalEventBus.$emit('showError', params.error.message);
            } else {
                await globalEventBus.$emit('showError', params.error);
            }
        }
        return {
            closeForm: true
        }
    }
    private async handleTableError(params: TableErrorHandlerParams): Promise<TableErrorHandlerResponse> {
        if (params.error) {

            console.log(params.error);
            // logout
            if (params.error.id && params.error.id === 10003) {
                await this.$store.commit("Auth/setAuthToken", '');
                await this.$ports.auth.logout();
            }
            if (params.error.message) {
                await globalEventBus.$emit('showError', params.error.message);
            } else {
                await globalEventBus.$emit('showError', params.error);
            }

            try {
                //await this.table.form.close();
            } catch (e) {
                console.log(e);
            }
        }
        return {};
        //this.cancel();
    }
    private errorHandler: ErrorHandler = {
        handleTableConfigError: this.handleTableError,
        handleTableLoadError: this.handleTableError,
        handleTableUnknownError: this.handleTableError,
        handleFormConfigError: this.handleFormError,
        handleFormLoadError: this.handleFormError,
        handleFormSaveError: this.handleFormError,
        handleFormUnknownError: this.handleFormError
    };

    private errorMessage: string = "";
    private gridName="BROWSE_FILIALBESTELLUNGSPOSITIONEN_HISTORIE";

    private get context(): string {
        return `Filiale=${this.$store.getters["Auth/branchId"]};`;
    }
    private selected:any[]=[];
    private canUpdate:boolean = false;
    private open: boolean = false;
    private parentId:number=0;

    public async show(parent:any, canUpdate:boolean): Promise<void> {
        this.errorMessage = "";
        this.canUpdate = canUpdate;
        this.parentId = parent.HALFRPOS_HAUPTAUFTRAGSPOSITION;
this.parentItem = parent;
        (<any>this.$refs["table"])?.reload(true);
        this.open = true;
    }

    private close(): void {
        (<any>this.$refs["table"])?.clearSelection();
        this.selected=[];
        this.parentId=0;
        this.open = false;
    }

    private save() {
        if(this.canUpdate) {
            globalEventBus.$emit("writeHistoryValues", { selected: this.selected[0], parentItem: this.parentItem});
        }
        this.close();
    }
}
</script>

<style>

</style>
